import { useSearchParams } from 'react-router'

export function usePanelInviteModal() {
  const [searchParams, setSearchParams] = useSearchParams()

  const panelInviteSource = searchParams.get(
    PANEL_INVITE_MODAL_SEARCH_PARAMS.source,
  )

  const panelInviteSourceId = searchParams.get(
    PANEL_INVITE_MODAL_SEARCH_PARAMS.sourceId,
  )

  return {
    isShowing: !!panelInviteSource && !!panelInviteSourceId,
    show: (options: {
      panelInviteSource: string
      panelInviteSourceId: number
    }) => {
      searchParams.set(
        PANEL_INVITE_MODAL_SEARCH_PARAMS.source,
        options.panelInviteSource,
      )
      searchParams.set(
        PANEL_INVITE_MODAL_SEARCH_PARAMS.sourceId,
        options.panelInviteSourceId.toString(),
      )

      setSearchParams(searchParams)
    },

    setTab(tab: string) {
      searchParams.set(PANEL_INVITE_MODAL_SEARCH_PARAMS.tab, tab)
      setSearchParams(searchParams)
    },

    hide: () => {
      Object.values(PANEL_INVITE_MODAL_SEARCH_PARAMS).forEach((paramKey) => {
        searchParams.delete(paramKey)
      })

      setSearchParams(searchParams)
    },
  }
}

export const PANEL_INVITE_MODAL_SEARCH_PARAMS = {
  source: 'panelInviteSource',
  sourceId: 'panelInviteSourceId',
  tab: 'panelInviteTab',
}
